import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Button, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import MenuIcon from '@mui/icons-material/Menu';
import HamMenu from './HamMenu';


function ElevationScroll(props) {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
        style: {
            backgroundColor: trigger ? "#282A3A" : "black",
            transition: trigger ? "0.3s" : "0.5s",
            boxShadow: 0,
        }
    });
}
const pages = [
    {
        title: 'Home',
        linkRef: '/'
    },
    {
        title: 'About',
        linkRef: '/#about'
    },
    {
        title: 'Work',
        linkRef: '/#work'
    },
    {
        title: 'Contact',
        linkRef: '/contact'
    },
]

ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
};

export default function Navbar(props) {
    const [hamMenu,setHamMenu]=React.useState(false);

    const handleOpen=(e)=>{
        e.preventDefault();
        setHamMenu(true);
    }
    const handleClose=(e)=>{
        e.preventDefault();
        setHamMenu(false);
    }
    

    return (
        <React.Fragment>
            <CssBaseline />
            <ElevationScroll {...props}>
                <AppBar >
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>
                            <Box sx={{ flexGrow: 1, display: { xs: 'none',md:"flex",lg: 'flex' }, marginLeft: "auto", justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                                <Typography
                                    variant="h6"
                                    noWrap
                                    component="a"
                                    href="/"
                                    sx={{
                                        mr: 2,
                                        display: { xs: 'none',md:"flex", lg: 'flex' },
                                        fontFamily: 'Title',
                                        // fontWeight: 700,
                                        fontSize: "1.5rem",
                                        letterSpacing: '.2rem',
                                        color: 'inherit',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Mann
                                </Typography>
                                <Box sx={{ flexGrow: 1, display: { xs: 'none',md:"flex", lg: 'flex' }, justifyContent: "right" }}>
                                    {pages.map((page) => (
                                        <Button href={page.linkRef}
                                            key={page.title}
                                            sx={{ my: 2, color: 'white', display: 'block', mr: 3, ml: 3, padding: 1, ":hover": { bgcolor: '#FDDF9E', color: 'black' } }}
                                        ><Typography
                                            noWrap
                                            sx={{
                                                display: { xs: 'none',md:"flex", lg: 'flex' },
                                                fontFamily: 'Title',
                                                // fontSize:20,
                                                // fontWeight: 700,
                                                letterSpacing: '.2rem',
                                                color: 'inherit',
                                                textDecoration: 'none',
                                                textAlign: "center",
                                                textTransform: "capitalize"
                                            }}
                                        >
                                                {page.title}
                                            </Typography>
                                        </Button>
                                    ))}
                                </Box>
                            </Box>
                            <Box sx={{ flexGrow: 1, display: { xs: 'flex',md:"none", lg: 'none' }, justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                                <Typography
                                    variant="h6"
                                    component="a"
                                    href="/"
                                    sx={{
                                        display: { xs: 'block', md:"none", lg: 'none' },
                                        fontFamily: 'Title',
                                        // fontWeight: 700,
                                        fontSize: "1rem",
                                        letterSpacing: '.2rem',
                                        color: 'inherit',
                                        textDecoration: 'none',
                                        mr:"auto"
                                    }}
                                >
                                    Mann
                                </Typography>
                                <IconButton mr="auto" sx={{display: { xs: 'flex', md:"none", lg: 'none' },
                                    color: "white", borderColor: "white", borderRadius: 20,
                                    ":active": { backgroundColor: "#FDDF9E", color: "#1D1F2A", }
                                }} onClick={()=>{setHamMenu(!hamMenu)}} >
                                    <MenuIcon ></MenuIcon>
                                </IconButton>

                            </Box>
                        </Toolbar>
                    </Container>
                </AppBar>
            </ElevationScroll>
            <HamMenu open={hamMenu} setOpen={()=>{setHamMenu(!hamMenu)}} pages={pages} />
        </React.Fragment >
    );
}